'use client';

import { Skeleton } from '@/components/ui';
import { useIsMobile } from '@/hooks/useDeviceType';

export function MessagesSkeleton() {
  const isMobile = useIsMobile();

  // Mobile skeleton
  if (isMobile) {
    return (
      <div className="overflow-hidden w-full">
        <Skeleton className="h-6 w-32 mx-6 my-6" />
        <div className="px-4 w-full h-[calc(100vh-212px)] pb-16 overflow-y-auto overflow-x-hidden bg-primary">
          <div className="flex flex-col">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="flex flex-col">
                <div className="flex w-full rounded-xl gap-3 px-3 py-4">
                  {/* Property Image */}
                  <Skeleton className="h-16 w-16 flex-shrink-0 rounded-lg" />
                  {/* Content */}
                  <div className="flex-1 flex min-w-0 flex-col gap-1">
                    {/* Address and Timestamp */}
                    <div className="flex items-start justify-between gap-2">
                      <Skeleton className="h-4 w-32" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                    {/* Beds/Baths */}
                    <Skeleton className="h-3 w-24" />
                    {/* Price */}
                    <Skeleton className="h-4 w-20" />
                  </div>
                </div>
                {index < 4 && <div className="h-px bg-secondary my-1" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Desktop skeleton
  return (
    <div className="h-[calc(100vh-92px)] overflow-hidden pb-8">
      <div className="h-full grid grid-cols-4 md:grid-cols-8 gap-x-8 lg:grid-cols-12 max-w-screen-xl mx-auto grid-rows-[auto_1fr]">
        <div className="col-start-2 col-span-full py-8 px-4">
          <Skeleton className="h-8 w-32" />
        </div>
        {/* Left Column: Chat List Skeleton */}
        <div className="col-start-2 col-span-4 pl-4 overflow-y-auto overflow-x-hidden bg-primary">
          <div className="flex flex-col">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="flex flex-col">
                <div className="flex w-full rounded-xl gap-3 px-3 py-4">
                  {/* Property Image */}
                  <Skeleton className="h-16 w-16 flex-shrink-0 rounded-lg" />
                  {/* Content */}
                  <div className="flex-1 flex min-w-0 flex-col gap-1">
                    {/* Address and Timestamp */}
                    <div className="flex items-start justify-between gap-2">
                      <Skeleton className="h-4 w-32" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                    {/* Beds/Baths */}
                    <Skeleton className="h-3 w-24" />
                    {/* Price */}
                    <Skeleton className="h-4 w-20" />
                  </div>
                </div>
                {index < 5 && <div className="h-px bg-secondary my-1" />}
              </div>
            ))}
          </div>
        </div>
        {/* Right Column: Message Window Skeleton */}
        <div className="hidden lg:block col-start-6 col-span-6 bg-primary overflow-hidden">
          <div className="flex h-full items-center justify-center">
            <div className="text-center space-y-2 h-full w-full">
              <Skeleton className="h-full w-full mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
